/* global window, document */

import React from 'react';
import PropTypes from 'prop-types';

import Navigation from './navigation/View';
import Header from './header/View';
import Content from './content/View';

import './Style.css';

class Template extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSmaller: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const distanceY = window.scrollY || document.body.scrollTop;
    const shrinkOn = 150;

    if (!this.state.isSmaller && distanceY > shrinkOn) {
      this.setState({
        isSmaller: true,
      });
    }

    if (this.state.isSmaller && distanceY <= shrinkOn) {
      this.setState({
        isSmaller: false,
      });
    }
  }

  render() {
    return (
      <div className="Template">
        <Header isSmaller={this.state.isSmaller} />
        <div className={`Template-content-wrapper${this.state.isSmaller ? ' smaller' : ''}`}>
          <Navigation isSmaller={this.state.isSmaller} />
          <Content>
            {this.props.children}
          </Content>
        </div>
      </div>
    );
  }
}

Template.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Template.defaultProps = {
  children: null,
};

export default Template;



// WEBPACK FOOTER //
// ./src/template/View.js